<template>
  <v-app-bar app color="grey darken-4" dark height="75">
    <div v-if="!isACast" class="item wd-status-agent">
      <Status :isTwilioInitialized="isTwilioInitialized" @rejectTask="reject"/>
    </div>
    <div v-if="!isACast" @click="showListWorkers = true" class="item position-relative">
      <p class="text-top">{{ workerTalking }}/{{ workerAvailable }}</p>
      <p class="fs-14 description">通話中/受付可</p>
      <v-list v-if="workers && showListWorkers" v-click-outside="hideListWorkers" class="workers_list position-absolute py-5">
        <v-list-item
          v-for="(worker, index) in workers"
          :key="index"
        >
          <v-list-item-title class="item mb-4">
            <span :class="worker.status !== 'null' ? worker.status : 'grey'" class="main-call_status"></span>
            <div class="main-call_user_avatar float-left">
              <img
                :src="worker.avatar || avatar_default"
                alt=""
              />
            </div>
            <div class="main-call_user_name mt-1 grey--text text--darken-4">
              <div class="mb-1 font-weight-bold">{{ worker.activityName }}</div>
              <div class="mb-0">{{ worker.name }}</div>
            </div>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
    <div class="horizontal-scroll w-100">
      <div class="item-list">
        <div
          class="call-item float-left"
          v-if="headerIsCalling"
        >
          <div class="ml-3 mr-4 mt-2 text-left fs-14 d-inline-block float-left call-info" v-if="task">
            {{ phoneNumber }} <br />
            {{ formatePhoneNumber(caller) }}
            <p class="fs-8 font-weight-thin twilio-phone mb-0">着信番号：{{ twilioFriendlyName }}</p>
          </div>
          <button class="main-call_header-btn danger d-inline-block float-left mt-5" @click="reject(true)">
            <i class="fas fa-phone-slash mt-0"></i>
          </button>
          <button class="main-call_header-btn d-inline-block float-left mt-5" :class="isAcceptable ? 'success' : 'secondary'" :disabled="!isAcceptable" @click="accept(getReservation.sid)">
            <i class="fas fa-phone-alt mt-0"></i>
          </button>
          <div class="red--text d-inline-block mt-10 mr-4 fs-14">{{ statusText }}</div>
        </div>
        <template v-if="currentConferences.length">
          <div v-for="(conference, key) in currentConferences" :key="key" class="call-item call-monitoring">
            <div class="d-inline-block ml-3 mr-2 text-left fs-14 mt-2 call-info">
              {{ conference.name }} <br />
              {{ formatePhoneNumber(conference.phone) }} <br />
              <p class="fs-8 font-weight-thin twilio-phone mb-0">{{ conference.friendlyName.includes('incoming') || conference.isTransferred ? '着信番号：' : '発信番号：' }}{{ formatePhoneNumber(conference.twilioPhone) }}</p>
            </div>
            <div class="d-inline-block align-super"
                 v-if="conference.agent !== userInfo.friendly_name"
                 :class="{ 'hover-pointer' : !isCoaching(), 'coaching': isCoaching(), 'hide': conference.is_transfer }"
                 @click="monitoring(conference)"
            >
              <span class="grey darken-1 px-1 py-2-custom rounded-circle fs-18">
                <i class="fa fa-headphones" aria-hidden="true"></i>
              </span>
              <div class="fs-7">モニタリング</div>
            </div>
            <div :key="`${reloadConf}${key}`"  class="d-inline-block ml-2 mr-3 text-left green--text align-super fs-14">
              {{ getAgentName(conference.agent) }} <br />
              {{ conference.hold ? '保留中' : '通話中' }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <button
      class="btn-custom btn btn-default ml-auto mr-3 text-white"
      style="white-space: nowrap;min-width: auto;"
      @click="onLogout"
    >
      ログアウト <i class="fas fa-sign-out-alt ml-2"></i>
    </button>
    <div class="version">{{ version }}</div>
  </v-app-bar>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { bus } from '@/main'
import { mapGetters, mapMutations } from 'vuex'
import Status from '@/components/Status'
import twilioDevice from '../../utils/twilioDevice'
import PckageJson from '../../../package.json'
console.log(PckageJson)

const UsersRepository = RepositoryFactory.get('users')
const PhonesRepository = RepositoryFactory.get('phones')
const PhoneAccountRepository = RepositoryFactory.get('phoneAccount')
const TwilioRepository = RepositoryFactory.get('twilio')
const StatisticRepository = RepositoryFactory.get('statistic')

const READY_STATUS = 'ready'

export default {
  name: 'Header',
  props: {
    isTwilioInitialized: Boolean
  },
  components: { Status },
  data () {
    return {
      showListWorkers: false,
      phoneNumber: null,
      twilioFriendlyName: null,
      transferTimeout: null,
      callQueueingTimeout: null,
      statusText: '着信中',
      avatar_default: window.location.origin + '/img/default-avatar.png',
      isAcceptable: false
    }
  },
  watch: {
    task(val) {
      if (val) {
        const { attributes } = val
        if (attributes.type === 'call-transfer') {
          this.transferTimeout = setTimeout(() => {
            this.reject(true)
          }, 10000)
        }
        // if (attributes.reciprocalType === 'transfer') {
        //   this.callQueueingTimeout = setTimeout(() => {
        //     this.$socket.emit('transfer-queue-calling', {
        //       taskId: val.sid,
        //       baseURL: process.env.VUE_APP_ENV_BASE_URL_API,
        //       data: {
        //         callSid: attributes.callSid,
        //         from: attributes.from,
        //         called: attributes.called,
        //         conferenceSid: attributes.conference.conferenceSid,
        //         friendly_name: attributes.conference.friendly_name,
        //         accountSid: attributes.accountSid,
        //         phone_transfer: attributes.phone_transfer,
        //         duration: attributes.duration,
        //         company_id: attributes.company_id
        //       }
        //     })
        //     this.removeCallHeader()
        //   }, attributes.duration * 1000)
        // }

        // if (attributes.reciprocalType === 'file') {
        //   this.callQueueingTimeout = setTimeout(async () => {
        //     await PhoneAccountRepository.deleteTask(val.sid)
        //     await this.removeCallHeader()
        //   }, attributes.duration * 1000)
        // }
      }
    },
    headerIsCalling(newVal) {
      if (newVal) {
        this.$root.$emit('playAudio')
        this.checkAcceptable()
      } else {
        this.reject()
      }
    }
  },
  async created() {
    await Promise.all([
      this.getWorkerStatus(),
      this.getCurrentConferences()
    ])
    bus.$on('changeStatus', () => {
      this.getWorkerStatus()
    })
    this.checkAcceptable()
    navigator.mediaDevices.ondevicechange = (event) => {
      this.checkAcceptable(true)
    }
    navigator.permissions.query({ name: 'microphone' }).then((permissionStatus) => {
      permissionStatus.onchange = () => {
        this.checkAcceptable(true)
      }
    })
  },
  destroyed () {
    bus.$off('changeStatus')
  },
  beforeUpdate: async function () {
    if (this.getReservation && this.task) {
      this.phoneNumber = await this.getPhoneNumber()
      this.twilioFriendlyName = await this.getTwilioNumberFriendlyName()
      this.statusText = (this.task?.attributes?.type === 'call-transfer')
        ? this.$t('header.incoming_transfer_call')
        : this.$t('header.incoming_call')
    }
  },
  sockets: {
    'worker-status': async function (data) {
      const workerData = {
        workers: data.listWorker,
        workerTalking: data.workerTalking,
        workerAvailable: data.workerAvailable
      }
      this.$store.commit('worker/SET_WORKER_DATA', workerData)
    },
    'start-conference': async function (data) {
      await this.addCurrentConferences(data)
    },
    'end-conference': async function (data) {
      this.removeCurrentConferences(data)
    },
    'conference-unhold': async function (data) {
      this.updateCurrentConferences(data.ConferenceSid, { hold: false })
    },
    'conference-hold': async function (data) {
      this.updateCurrentConferences(data.ConferenceSid, { hold: true })
    },
    'start-transfer': async function (data) {
      this.updateCurrentConferences(data.conference_sid, { is_transfer: true })
    },
    'cancel-transfer': async function (data) {
      this.updateCurrentConferences(data.conference_sid, { is_transfer: false })
    },
    'join-transfer': async function (data) {
      // Update reservationsCompleted of worker statistics
      if (data.callCenterNumber && data.fromUserId && this.userInfo.id === data.fromUserId && data.originalDirection !== 'OUTGOING') {
        await StatisticRepository.updateWorkerStatistic(data.callCenterNumber, data.fromUserId)
      }
      this.updateCurrentConferences(data.conference_sid, { agent: data.agent, callSidToCoach: data.callSidToCoach, is_transfer: false, isTransferred: true })
    },
    connect: async function () {
      if (!this.currentConferences.length) return
      await this.getCurrentConferences()
    }
  },
  methods: {
    onLogout () {
      this.$root.$emit('logout')
    },
    async getCurrentConferences () {
      const [currentUser, result] = await Promise.all([
        UsersRepository.getByWorkerSid(this.userInfo.worker_sid, true),
        TwilioRepository.getCurrentConferences()
      ])
      if (currentUser.success && currentUser.data) {
        this.setUserInfo({
          ...this.userInfo,
          block_calls: currentUser.data.block_calls
        })
      }
      if (result.status_code === 200) {
        if (this.userInfo?.block_calls && this.userInfo.block_calls.length) {
          const block_calls = this.userInfo.block_calls.filter(e => !e.can_call_incoming || !e.can_call_outgoing).map(e => e.twilio_phone)
          // eslint-disable-next-line array-callback-return
          result.data = result.data.filter(e => {
            if (!block_calls.includes(e.callCenter)) {
              return e
            }
          })
        }
        this.$store.commit('callMonitoring/SET_CURRENT_CONFERENCES', result.data)
      }
    },
    async addCurrentConferences (conference) {
      const currentUser = await UsersRepository.getByWorkerSid(this.userInfo.worker_sid, true)
      if (currentUser.success) {
        this.setUserInfo({
          ...this.userInfo,
          block_calls: currentUser.data.block_calls
        })
      }
      if (this.userInfo.block_calls.length && this.userInfo.block_calls.find(e => e.twilio_phone === conference.callCenter && (!e.can_call_incoming || !e.can_call_outgoing))) {
        return
      }
      this.$store.commit('callMonitoring/ADD_TO_CURRENT_CONFERENCES', conference)
    },
    async removeCurrentConferences (conference) {
      this.$store.commit('callMonitoring/REMOVE_FROM_CURRENT_CONFERENCES', conference.ConferenceSid)
    },
    async updateCurrentConferences (conferenceSid, data) {
      this.$store.commit('callMonitoring/UPDATE_CURRENT_CONFERENCES', { conferenceSid: conferenceSid, data: data })
    },
    isCoaching () {
      return (this.coachingConference && Object.keys(this.coachingConference).length) || this.isCalling
    },
    getAgentName (agentFriendlyName) {
      const worker = this.workers.filter(agent => agent.friendlyName === agentFriendlyName)[0]
      return worker ? worker.name : null
    },
    monitoring (conference) {
      if (twilioDevice.status() !== READY_STATUS) return
      if (this.isCoaching(conference)) return
      this.$store.commit('callMonitoring/SET_COACHING_CONFERENCE', conference)
      const routeData = this.$router.resolve({ name: 'CallMonitoring' })
      window.open(routeData.href, '', 'width=1280,height=700')
    },
    async getWorkerStatus () {
      if (this.isACast) return
      const result = await PhonesRepository.getWorkerStatus()
      if (result.status_code === 200) {
        const workerData = {
          workers: result.listWorker,
          workerTalking: result.workerTalking,
          workerAvailable: result.workerAvailable
        }
        this.$store.commit('worker/SET_WORKER_DATA', workerData)
      }
    },
    hideListWorkers () {
      this.showListWorkers = false
    },
    async getPhoneNumber () {
      const response = await PhoneAccountRepository.getPhoneNumber(this.caller)
      if (response.status_code === 200) {
        return response.data.name
      }
      return null
    },
    async getTwilioNumberFriendlyName () {
      const twilioPhone = this.task?.attributes?.type === 'call-transfer' ? this.task.attributes.callCenterNumber : this.called
      const response = await TwilioRepository.getTwilioPhone(twilioPhone)
      if (response.status_code === 200) {
        return response.data.friendly_name
      }
      return this.called
    },
    async accept (reservationSid) {
      console.log('debug log: accept reservation', this.getReservation, reservationSid)
      if (!this.getReservation) console.log('debug log: can not find reservation')
      localStorage.removeItem('closeCallWindow')
      if (this.transferTimeout) {
        clearTimeout(this.transferTimeout)
      }
      clearTimeout(this.callQueueingTimeout)
      const routeData = this.$router.resolve({
        name: 'Calling',
        query: {
          incoming: true,
          reservationSid: reservationSid,
          twilioFriendlyName: this.twilioFriendlyName
        }
      })

      localStorage.setItem('closeCallWindow', 'true')
      if (this.winCalling) {
        this.winCalling.close()
      }

      this.winCalling = window.open(routeData.href, '', 'width=1280,height=700')
    },
    async reject(isActionRejectTask = false) {
      const reservation = this.getReservation
      if (!reservation) return
      const { task } = reservation
      const { attributes } = task
      clearTimeout(this.callQueueingTimeout)

      if (attributes && attributes.type === 'call-transfer') {
        clearTimeout(this.transferTimeout)
        await PhoneAccountRepository.deleteTask(task.sid)
        return
      }
      if (isActionRejectTask) {
        TwilioRepository.rejectTask(task.sid)
      }
      TwilioRepository.updateReservationStatus('rejected', reservation.sid, reservation.taskSid)
    },

    removeCallHeader() {
      this.$store.commit('reservation/SET_RESERVATION', null)
      this.$root.$emit('stopAudio')
    },

    checkAcceptable (notifyAvailable = false) {
      if (this.headerIsCalling) {
        navigator.mediaDevices.getUserMedia({ video: false, audio: true }).then(() => {
          this.isAcceptable = true
          if (notifyAvailable) {
            this.$swal.fire({
              title: '',
              text: this.$t('messages.device_available'),
              allowOutsideClick: false,
              confirmButtonText: '閉じる'
            })
          }
        }).catch((err) => {
          this.isAcceptable = false
          let message = err.message
          if (err.name === 'NotFoundError') {
            message = this.$t('messages.device_not_found')
          }
          if (err.name === 'NotAllowedError') {
            message = this.$t('messages.device_not_allowed')
          }
          this.$swal.fire({
            title: '',
            text: message,
            allowOutsideClick: false,
            confirmButtonText: '閉じる'
          })
          console.error(err)
        })
      }
    },
    formatePhoneNumber (phoneNumber) {
      return phoneNumber.replace(/\+|-/g, '').replace(/^81/g, '0')
    },
    ...mapMutations({
      setUserInfo: 'user/SET_USER_INFO'
    })
  },
  computed: {
    version () {
      return `v${PckageJson.version}`
    },
    caller () {
      return this.task ? this.task.attributes.from : null
    },
    called () {
      return this.task ? this.task.attributes.called : null
    },
    headerIsCalling() {
      return this.getReservation && !this.isCalling
    },
    ...mapGetters('reservation', ['getReservation', 'task', 'reservationRejected', 'taskRejected']),
    ...mapGetters('status', ['allStatuses']),
    ...mapGetters('worker', ['workers', 'workerTalking', 'workerAvailable']),
    ...mapGetters({
      currentConferences: 'callMonitoring/getCurrentConferences',
      reloadConf: 'callMonitoring/reloadConf',
      coachingConference: 'callMonitoring/getCoachingConference',
      userInfo: 'user/getUserInfo',
      isCalling: 'twilioDevice/isCalling',
      isACast: 'user/getIsACast'
    })
  }
}
</script>
<style>
  .w-100 {
    width: 100%;
    overflow-x: auto;
    height: 100%;
    overflow-y: hidden;
    white-space: nowrap;
    /*position: relative;*/
  }
  .item-list {
    /*position: absolute;*/
    top: 0;
    bottom: -15px;
    left: 0;
    right: 0;
    overflow: auto;
  }
  .call-item {
    /*min-width: 260px;*/
    border-right: 2px solid #484848;
    text-align: center;
    height: 100%;
    display: inline-block;
  }
  ::-webkit-scrollbar {
    height: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .coaching i {
    color: #999;
  }
  .call-monitoring .d-inline-block.hide {
    display: none !important;
  }
  .wd-status-agent{
    min-width: auto !important;
  }
  .call-info {
    line-height: 1.6;
  }
  .twilio-phone {
    color: #cbcbcb;
    margin-top: 1px;
  }
  .align-super {
    vertical-align: super;
  }
  .version {
    position: absolute;
    top: 4px;
    right: 4px;
    font-weight: 300;
    font-size: 8px;
    white-space: nowrap;
    pointer-events: none;
  }
</style>
